import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { providerLabel } from '../../utils/crmContext';
import '../../styles/components/crmExistingBookingNotice.less';

// The notice on a booking a CRM creation link was sent to INSTEAD of a new form (MS-6671, T4.11).
//
// A salesperson clicked "book" in the CRM and expected an empty form; they are looking at a
// booking that already exists. Without a word about why, the natural next move is to go back and
// click again, or to start a walk-in booking beside it — the very duplicate the rule exists to
// stop. So the one thing this says is why they are here and what to do: this lead already has this
// live booking, carry on with it.
//
// It renders only when the route carries book-api's marker (the overview decides that with
// arrivedAtExistingBooking); the CRM's name comes off the booking's own origin column, and nothing
// about the buyer is repeated here — the booking page already shows them.
const ns = { ns: TRANSLATION_FILES.translation };

export function CrmExistingBookingNotice({ show, provider, t }) {
  if (!show) return null;
  const crm = providerLabel(provider) || t('the CRM', ns);
  return (
    <div className="crm-existing-booking-notice" role="status" data-testid="crm-existing-booking-notice">
      <Icon name="linkify" />
      <span>
        {t('This lead already has a live booking, so {{crm}} opened it instead of starting a new one. Continue with this booking.', { ...ns, crm })}
      </span>
    </div>
  );
}

CrmExistingBookingNotice.propTypes = {
  show: PropTypes.bool,
  provider: PropTypes.string,
  t: PropTypes.func.isRequired,
};

CrmExistingBookingNotice.defaultProps = {
  show: false,
  provider: '',
};

export default withTranslation(namespaces)(CrmExistingBookingNotice);



// WEBPACK FOOTER //
// ./src/components/Crm/CrmExistingBookingNotice.jsx